
import { locale } from './globals.js';
import { getOffset, throttle, viewport } from './toolbox.js';

const arrowBtn = function (dir) {
  return `<button class="arrow ${dir} custom">
    <i class="fal fa-chevron-circle-${locale[dir]} icon"></i>
  </button>`
}

class PartnersSlider {
  constructor(el) {
    if(!el) return false;
    this.el = el;
    this.rtl = (locale.dir == 'rtl');
    this.align = (locale.dir == 'ltr') ? 'left' : 'right';
    this.initSlider();
  }
  initSlider () {
    this.swiper = new Swiper('.partners-slider', {
      slidesPerView: 'auto',
      slidesOffsetBefore: 50,
      slidesOffsetAfter: 50,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })

  }
}
export default function () {
  Array.from(document.querySelectorAll('[data-partners-slider]')).forEach( (box) => {
    new PartnersSlider(box);
  });
}
